import { useQuery } from "@tanstack/react-query";
import { fetchUnmatched } from "../api/unmatched";
import type { UnmatchedResult } from "../api/unmatched";

export function useUnmatched(enabled: boolean) {
  return useQuery<UnmatchedResult>({
    queryKey: ["unmatched"],
    queryFn: fetchUnmatched,
    staleTime: 30_000,
    enabled,
  });
}
